// src/redux/slices/lotAndContainerDetailsSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ILotAndContainerDetailsState {
    show: boolean;
    lotId?: number;
    containerId?: number;
}

export const initialStateLotAndContainerDetails: ILotAndContainerDetailsState = {
    show: false,
    lotId: undefined,
    containerId: undefined,
};

const lotAndContainerDetailsSlice = createSlice({
    name: "lotAndContainerDetails",
    initialState: initialStateLotAndContainerDetails,
    reducers: {
        showLotAndContainerDetails: (
            state,
            action: PayloadAction<{ lotId?: number; containerId?: number }>,
        ) => {
            state.show = true;
            state.lotId = action.payload.lotId;
            state.containerId = action.payload.containerId;
        },
        hideLotAndContainerDetails: (state) => {
            state.show = false;
            state.lotId = undefined;
            state.containerId = undefined;
        },
    },
});

export const { showLotAndContainerDetails, hideLotAndContainerDetails } =
    lotAndContainerDetailsSlice.actions;

export default lotAndContainerDetailsSlice.reducer;
